import { createFileRoute } from '@tanstack/react-router';
import Login from 'containers/Login';
import { AppLoader } from '../-components/AppLoader';

export const Route = createFileRoute('/login/')({
  pendingComponent: AppLoader,
  component: Login,
});
